var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoGuidIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9768_229540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F6F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9768_229540)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.1631,
    y: 11.1629,
    width: 237.209,
    height: 298.605,
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 57.3741,
    y1: 10.634,
    x2: 8.53686,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 36.4444,
    y1: 10.634,
    x2: -12.3928,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    x1: 71.3277,
    y1: 10.634,
    x2: 22.4905,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    x1: 50.398,
    y1: 10.634,
    x2: 1.56079,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x1: 29.4678,
    y1: 10.634,
    x2: -19.3694,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    x1: 64.3511,
    y1: 10.634,
    x2: 15.5139,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    x1: 43.4214,
    y1: 10.634,
    x2: -5.41578,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    x1: 22.4908,
    y1: 10.634,
    x2: -26.3464,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    x1: 15.5142,
    y1: 10.634,
    x2: -33.323,
    y2: 59.4712,
    stroke: "#434343",
    strokeWidth: 2.44186
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 25.1167,
    y: 25.115,
    width: 34.8837,
    height: 45.3488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    x1: 37.0928,
    y1: 35.4639,
    x2: 59.1858,
    y2: 35.4639,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    x1: 37.0928,
    y1: 41.0454,
    x2: 59.1858,
    y2: 41.0454,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    x1: 37.0928,
    y1: 46.6269,
    x2: 59.1858,
    y2: 46.6269,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    x1: 37.0928,
    y1: 52.2084,
    x2: 59.1858,
    y2: 52.2084,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    y: 11.1629,
    width: 11.1628,
    height: 42.5581,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 51.6279,
    y: 9.76674,
    width: 1.39535,
    height: 40.4651,
    transform: "rotate(90 51.6279 9.76674)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 30,
    cy: 30,
    r: 29.186,
    stroke: "#F5F5F5",
    strokeWidth: 1.62791
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGuidIcon2);
export default __webpack_public_path__ + "static/media/photo-guid-icon-2.01502fe79518cc0b59a84834e0a5fcba.svg";
export { ForwardRef as ReactComponent };